// user.js
const state = {
    webUrl: "scm.al-peanut.com",
    obj: {
        webUrl: "",
        webIcp: "",
        email: "",
        phone: "",
        msg: "",
        webTitle: "花升数联",
        logoUrl: "./xingyunsi_logo.png",
        headerLogoUrl: "./xingyunsi_small.png",
        icon: "/jcy.ico",
    },
    webObj: [
        {
            webTitle: "花升数联",
            icon: "/jcy.ico",
            webUrl: "scm.al-peanut.com",
            logoUrl: "./xingyunsi_logo.png",
            headerLogoUrl: "./xingyunsi_small.png",
            tel: "400-840-8088",
            webIcp: "浙ICP备20022022号-5",
            email: "server@enower.com",
            phone: "400-840-8088",
            msg: "2016-2026©花升数联",
            keFu: "./images/zhilidao_kefu.png",
            tplId: "255551",
            accountName: "杭州浙礼道电子商务有限公司",
            openingBank: "中国银行杭州市高新技术开发区",
            account: "380583029691"
        }

    ]
};

const mutations = {
    SET_WEBICP(state, payload) {
        state.obj = payload;
        document.title = payload.webTitle;
    },
    SET_ICON(state, payload) {
        const link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = payload.icon;
        const head = document.head || document.getElementsByTagName('head')[0];
        const oldFavicons = document.querySelectorAll('link[rel="icon"]');
        oldFavicons.forEach(oldFavicon => head.removeChild(oldFavicon));
        head.appendChild(link);
    }
};

const actions = {
    /**
     * 设置webIcp
     */
    setWebIcp({ commit }, amount) {
        commit('SET_WEBICP', amount)
        commit('SET_ICON', amount)
    },
    setIcon({ commit }, amount) {
        commit('SET_ICON', amount)
    }
};

const getters = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
